import { create } from "zustand"
import { immer } from "zustand/middleware/immer"
import { z } from "zod"

// Zod schemas for validation
const AudioStateSchema = z.object({
    currentAudio: z.instanceof(HTMLAudioElement).optional(),
})

// Store state interface
export interface AudioStoreState {
    currentAudio: HTMLAudioElement | undefined
}

// Store actions interface
export interface AudioStoreActions {
    playAudio: (audio: HTMLAudioElement, audioUrl: string) => void
    pauseAudio: () => void
    setCurrentAudio: (audio: HTMLAudioElement | undefined) => void
}

export type AudioStore = AudioStoreState & AudioStoreActions

export const useAudioStore = create<AudioStore>()(
    immer((set, get) => ({
        // State
        currentAudio: undefined,

        // Actions
        playAudio: (audio: HTMLAudioElement, audioUrl: string) => {
            set((state) => {
                // Pause current audio if playing
                if (state.currentAudio) {
                    state.currentAudio.pause()
                }

                // Set new audio and play
                state.currentAudio = audio
                audio.play()
            })
        },

        pauseAudio: () => {
            set((state) => {
                if (state.currentAudio) {
                    state.currentAudio.pause()
                }
            })
        },

        setCurrentAudio: (audio: HTMLAudioElement | undefined) => {
            set((state) => {
                state.currentAudio = audio
            })
        },
    }))
)
